export default {
      id: "modify-sausage-usage",
      viewBox: "0 0 10.4 10",
      url: "assets/" + "sprite.svg#modify-sausage-usage",
      toString: function () {
        return this.url;
      }
    }